<template>
    <v-alert
      v-model="errorVisibility"
      dismissible
      :input="clearError"
      type="error"
      class="my-0"
    >
      {{msg}}
    </v-alert>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'main-errors',
  props: ['msg', 'index'],
  computed: {
    errorVisibility: {
      get() {
        return this.msg;
      },
      set() {
        this.clearError(this.index);
      },
    },
  },
  methods: {
    ...mapActions('app', [
      'clearError',
    ]),
  },
};
</script>
